import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

/**
 * Deliberately separate from services/api.js: that instance attaches a
 * stored auth token and redirects to /login on 401, neither of which makes
 * sense on the public, unauthenticated form-fill page (see
 * routes/public.js on the backend) - the person filling it in never logs in
 * at all.
 */
const publicApi = axios.create({
  baseURL: `${API_URL}/public`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default publicApi;
